import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
const targetAudience = ['Emprendedores que acaban de empezar y necesitan su primera venta', 'Vendedores con producto pero sin clientes', 'Personas que necesitan ingresos en días, no en meses', 'Quien está cansado de publicar en redes sin resultados', 'Freelancers que quieren validar su servicio rápidamente', 'Coaches y consultores buscando sus primeros clientes pagos'];
export function WhoThisIsFor() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full py-16 md:py-24 bg-white" data-id="element-137">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-5xl" data-id="element-138">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="space-y-12" data-id="element-139">
          <div className="text-center space-y-4" data-id="element-140">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#1e3a8a]" data-id="element-141">
              ¿Para Quién Es Esto?
            </h2>
            <p className="text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-142">
              Este método está diseñado específicamente para:
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-143">
            {targetAudience.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} animate={isInView ? {
            opacity: 1,
            x: 0
          } : {}} transition={{
            delay: index * 0.1,
            duration: 0.5
          }} className="flex items-start gap-4 bg-[#faf8f5] p-6 rounded-lg border-2 border-[#f97316]/20 hover:border-[#f97316] transition-colors" data-id="element-144">
                <CheckCircle2Icon className="w-8 h-8 text-[#f97316] flex-shrink-0 mt-1" data-id="element-145" />
                <p className="text-lg text-gray-800 font-medium" data-id="element-146">{item}</p>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          delay: 0.6,
          duration: 0.5
        }} className="bg-gradient-to-r from-[#1e3a8a] to-[#1e2a5a] p-8 rounded-2xl text-center" data-id="element-147">
            <p className="text-xl md:text-2xl text-white font-semibold" data-id="element-148">
              Si necesitas resultados{' '}
              <span className="text-[#f97316] font-bold" data-id="element-149">AHORA</span>, no en 6
              meses, este método es para ti.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}